<div class="viewer-container">
  <rdrx-modal-header (closeEvent)="dialogRef.close()">
    <h2 class="modal-header" id="simple-message-modal-h2">{{ title }}</h2>
  </rdrx-modal-header>

  <div class="body" data-automation-id="footnote-modal-body">
    <div [innerHTML]="messageText"></div>
  </div>
  @if (isLoading$ | async) {
    <div class="message-loading">
      {{ 'dialog.loading_message' | translate }}
    </div>
  }
  @if (error$ | async) {
    <div class="message-error">
      <mhe-alert data-automation-id="simple-message-error-alert" [type]="alertType.Error" [closable]="false">
        {{ 'dialog.failed_message' | translate }}
      </mhe-alert>
    </div>
  }
</div>
